import { create } from 'zustand';

import { IModalSystem, IModalSystemStore } from './types';

export const openModal = (modal: IModalSystem) => {
  useModalSystem.setState((state) => {
    const isModalExists =
      state.modals.some((m) => m.id === modal.id) || state.modals.length > 3;
    if (isModalExists) return state;

    return {
      modals: [...state.modals, modal],
    };
  });
};

export const openOutsideDisabledModal = (
  modal: Omit<IModalSystem, 'disableOutsideClick'>,
) => {
  openModal({ ...modal, disableOutsideClick: true });
};

export const closeModal = (id: string) => {
  useModalSystem.setState((state) => ({
    modals: state.modals.filter((modal) => modal.id !== id),
  }));
};

export const closeAllModals = () => {
  useModalSystem.setState({ modals: [] });
};

export const useModalSystem = create<IModalSystemStore>(() => ({
  modals: [],
  openModal,
  closeModal,
  closeAllModals,
}));
